import PrivateClassLessonsDao from '../dao/private-class-lessons.dao';
import type { PrivateClassLesson } from '../interfaces';
import type { Environment } from '../interfaces/environment';

export abstract class PrivateClassLessonsService {
  static async getPrivateClassLessons(
    env: Environment,
    contactId: string,
    lessonTrackUuid?: string,
    forTeacher?: boolean,
    showFreeFormLesson?: boolean
  ): Promise<PrivateClassLesson[]> {
    if (!lessonTrackUuid) {
      throw new Error('Missing lessonTrackUuid');
    }

    return PrivateClassLessonsDao.getPrivateClassLessons(
      env,
      contactId,
      lessonTrackUuid,
      forTeacher,
      showFreeFormLesson
    );
  }
}
